<template>
  <div>
    <template>
      <v-btn
        dark
        block
        color="primary "
        class="rounded-pill mb-4"
        @click.stop="groupeDialog = true"
      >
        <v-icon class="mr-4">mdi-account-multiple-plus</v-icon> Nouveau groupe
        {{ projet }}
      </v-btn>
    </template>
    <v-dialog
      v-model="groupeDialog"
      fullscreen
      hide-overlay
      transition="slide-x-transition"
    >
      <v-card>
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <v-btn icon @click="resetNewUserForm()">
              <v-icon>mdi-arrow-left</v-icon> </v-btn
            >Nouveau Groupe {{ projet }} de {{ utilisateur.displayName }}
          </v-toolbar-title>
        </v-app-bar>
        <v-card-text class="pb-0">
          <v-form ref="form_new_user" lazy-validation>
            <v-container fluid>
              <v-row no-gutters="">
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="nom_groupe"
                    label="Nom du groupe"
                    prepend-icon="person"
                    :rules="requis"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="president"
                    label="Président"
                    prepend-icon="mdi-shield-account"
                    :rules="requis"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedDateFormattedMomentjs"
                        label="Date de constitution"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="date_constitution"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" hidden>
                  <v-select
                    v-model="projets_selected"
                    :items="utilisateur.projets"
                    chips
                    label="Projets"
                    multiple
                    solo
                    item-text="ll_programme"
                    item-value="ll_programme"
                    @change="logProjectSelected()"
                    :rules="selectRules"
                  ></v-select>
                </v-col>

                <v-col v-if="showDistricts" cols="12">
                  <v-autocomplete
                    hint="Districts"
                    dense
                    @change="setCommunes()"
                    :rules="selectRules"
                    :items="_.sortBy(utilisateur.districts, ['ll_district'])"
                    label="Districts"
                    item-value="id"
                    item-text="ll_district"
                    solo
                    v-model="district_selected"
                    required
                    ref="district_selected"
                    :loading="communeLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col v-if="showCommunes" cols="12">
                  <v-autocomplete
                    hint="Communes"
                    dense
                    @change="setFokontanys()"
                    :rules="selectRules"
                    :items="_.sortBy(communes, ['ll_commune'])"
                    label="Communes"
                    item-value="id"
                    item-text="ll_commune"
                    solo
                    required
                    v-model="commune_selected"
                    ref="commune_selected"
                    :loading="fokontanyLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col v-if="showFokontanys" cols="12">
                  <v-autocomplete
                    hint="Fokontany"
                    dense
                    :items="_.sortBy(fokontanys, ['ll_fokontany'])"
                    :rules="selectRules"
                    label="Fokontany"
                    item-value="id"
                    item-text="ll_fokontany"
                    solo
                    required
                    v-model="fokontany_selected"
                    ref="fokontany_selected"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col v-if="showFokontanys" cols="12">
                  <v-text-field
                    dense
                    v-model="village"
                    label="Village"
                    prepend-icon="mdi-map"
                    :rules="requis"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-4">
          <v-btn
            class="rounded-pill neumorphic warning"
            @click="resetNewUserForm"
            >Annuler</v-btn
          >
          <v-btn
            class="rounded-pill neumorphic primary"
            :loading="newUserLoading"
            @click="createGroupe"
            >Créer le groupe</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.GetUserdetails(this.utilisateur.uid);
  },
  props: {
    projet: {
      type: String,
      required: true,
    },
    utilisateur: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      userDetails: [],
      projets_selected: [this.projet],
      projectFiltered: [],
      projectList: [],
      menu2: false,
      groupeDialog: false,
      newFokontanyloader: false,
      districtLoading: false,
      communeLoading: false,
      fokontanyLoading: false,
      newUserLoading: false,
      valid: true,
      email: "",
      provinces: [],
      regions: [],
      communes: [],
      fokontanys: [],
      village: "",
      president: "",
      date_constitution: this.$moment().toISOString(),
      new_fokontany: "",
      Fokontanydata: "",
      showRegions: true,
      showDistricts: true,
      showCommunes: false,
      showFokontanys: false,
      showNewFokontany: false,
      province_selected: "",
      region_selected: "",
      district_selected: "",
      commune_selected: "",
      fokontany_selected: "",
      nom_groupe: "",
      email: "",
      password: "",
      roles: [],
      show1: false,
      dialog: false,
      ll_province: "",
      id_province: "",
    };
  },

  computed: {
    computedDateFormattedMomentjs() {
      return this.date_constitution
        ? this.$moment(this.date_constitution).format("DD-MM-YYYY")
        : "";
    },
    ...mapState({
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isGroupe: (state) => state.Auth.isGroupe,
    }),
  },

  methods: {
    logProjectSelected() {
      let self = this;
      const filtered = _.filter(this.utilisateur.projets, function (projet) {
        return _.includes(self.projets_selected, projet.ll_programme);
      });
      this.projectFiltered = filtered;
      let listArray = [];
      filtered.forEach(function (projet, index) {
        listArray[index] = projet.id;
      });
      this.projectList = listArray;
    },

    ...mapActions({
      addOneItem: "Groupes/addOneItem",
    }),
    GetUserdetails(idUser) {
      let self = this;
      var userRef = this.$firebase.firestore().collection("users").doc(idUser);
      userRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            self.userDetails.push({
              ...doc.data(),
              id: doc.id,
            });

            let userUid = self.userDetails[0].uid.toString();
          } else {
            // doc.data() will be undefined in this case
            console.log("Pas de résultats");
          }
        })
        .catch(function (error) {
          console.log("Error ici getting document:", error);
        });
    },

    setRegions() {
      var array = this.$regions;
      var regionsFiltrees = array.filter(
        (region) => region.province_id_province === this.province_selected
      );
      this.showRegions = true;
      this.regions = regionsFiltrees;
      this.districts = [];
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showNewFokontany = false;

      this.showDistricts = false;
      this.showCommunes = false;
      this.showFokontanys = false;
    },

    setCommunes() {
      this.logProjectSelected();
      console.log(this.district_selected.toString());
      var self = this;
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showCommunes = true;
      this.showFokontanys = false;
      this.showNewFokontany = false;
      this.communeLoading = true;

      //getInfosDistrict
      var docRef = this.$firebase
        .firestore()
        .collection("districts")
        //.where("ll_", "==", true)
        .doc(this.district_selected.toString());

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            //console.log("Document data:", doc.data());
            self.ll_province = doc.data().ll_province;
            self.id_province = doc.data().province_id_province;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such  District!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });

      this.$firebase
        .firestore()
        .collection("communes")
        .where("id_district", "in", [
          this.district_selected.toString(),
          this.district_selected,
        ])
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var commune = doc.data();
            commune.id = doc.id;
            self.communes.push({
              ...commune,
            });
            self.communeLoading = false;
          });
        });
    },

    setFokontanys() {
      var self = this;
      this.fokontanys = [];
      this.showFokontanys = true;
      this.new_fokontany = "";
      this.fokontanyLoading = true;
      var query = this.$firebase
        .firestore()
        .collection("fokontanys")
        .where("id_commune", "in", [
          this.commune_selected.toString(),
          this.commune_selected,
        ]);

      query.get().then(function (snap) {
        if (snap.empty) {
          //console.log("no documents found");
          self.showNewFokontany = true;
          self.showFokontanys = false;
          self.fokontanyLoading = false;
        } else {
          self.showNewFokontany = true;
          self.showFokontanys = true;
          self.fokontanys = [];
          self.fokontanyLoading = false;

          snap.forEach((doc) => {
            var fokontany = doc.data();
            //console.log(fokontany);
            fokontany.id = doc.id;
            self.fokontanys.push({
              ...fokontany,
            });
          });
        }
      });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.groupeDialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    resetNewUserForm() {
      this.$refs.form_new_user.reset();
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showCommunes = false;
      this.showFokontanys = false;
      this.showNewFokontany = false;
      this.communeLoading = false;
      this.districtLoading = false;
      this.groupeDialog = false;
      this.newUserLoading = false;
    },

    createGroupe() {
      if (this.$refs.form_new_user.validate()) {
        let uuid = this.$uuid.v4();
        var self = this;
        this.newUserLoading = true;
        let newGroupe = {
          pin1: "1234",
          pin3: "1234",
          pin2: "1234",
          date_insert_gp: this.$moment(new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          date_constitution: this.$moment(this.date_constitution).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          id_region: this.$refs.district_selected.selectedItems[0]
            .regions_id_region,
          id_district: this.district_selected,
          ll_district: this.$refs.district_selected.selectedItems[0]
            .ll_district,
          nom_responsable: this.userDetails[0].displayName,
          latitude: "",
          longitude: "",
          id_commune: this.commune_selected,
          ll_fokontany: this.$refs.fokontany_selected.selectedItems[0]
            .ll_fokontany,
          newGroup: "1",
          active: "0",
          code_fokontany: this.fokontany_selected,
          ll_region: this.$refs.district_selected.selectedItems[0].ll_region,
          responsable: this.userDetails[0].id,
          president: this.president,
          ll_commune: this.$refs.commune_selected.selectedItems[0].ll_commune,
          password: "Osdrm123456",
          roles: {
            groupe: true,
          },
          ll_province: this.ll_province,
          id_province: this.id_province,
          nom_groupe: this.nom_groupe,
          email: this.nom_groupe + "_" + this.village + "@osdrmdatabase.online",
          village: this.village,
          projets: this.projectFiltered,
          projectList: this.projectList,
          hors_groupe: "0",
          menageGenerated: true,
          id:uuid
        };

       
        //groupesRequest
        /*  this.$firebase
          .firestore()
          .collection("groupesRequest")
          .doc(uuid)
          .set(newGroupe, { merge: true }); */

        //groupes
        this.$firebase
          .firestore()
          .collection("groupes")
          .doc(uuid)
          .set(newGroupe, { merge: true });

        //groupe insert To vuex
        this.addOneItem(newGroupe);
        console.log("groupe créé", newGroupe);
        this.newUserLoading = false;
        this.groupeDialog = false;
        this.resetNewUserForm();
        this.$emit("groupCreated");
      } else {
        console.log("Valider d'abord");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
